(function () {
  const sections = document.querySelectorAll('[data-fwh-section]');
  if (!sections.length) return;

  const revealSection = (section) => {
    if (section.dataset.fwhVisible === 'true') return;
    section.dataset.fwhReady = 'true';
    section.dataset.fwhVisible = 'true';

    const steps = section.querySelectorAll('[data-fwh-step]');
    steps.forEach((step, index) => {
      window.setTimeout(() => {
        step.classList.add('is-visible');
      }, 760 + index * 150);
    });
  };

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    sections.forEach((section) => revealSection(section));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        revealSection(entry.target);
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.24,
      rootMargin: '0px 0px -12% 0px'
    }
  );

  sections.forEach((section) => {
    section.dataset.fwhReady = 'true';
    observer.observe(section);
  });
})();
